import Vue from 'vue'
import Router from 'vue-router'
import backLayout from '@/back/layout'
import frontLayout from '@/front/layout'


export const constantRouterMap = [
  //#################### 前台 ####################
  {
    path:'/',
    name: '',
    component: frontLayout,
    children: [
      {
        path: '',
        name: '首页',
        component: () => import('@/front/index.vue'),
      },

      {
        path: '/organization',
        name: '组织机构',
        component: () => import('@/front/organization.vue'),
      },

      {
        path: '/research',
        name: '研究咨询',
        component: () => import('@/front/research.vue'),
      },

      {
        path: '/periodical',
        name: '期刊出版',
        component: () => import('@/front/periodical.vue'),
      },

      {
        path: '/inform',
        name: '通知公告',
        component: () => import('@/front/inform.vue'),
      },

      {
        path: '/party',
        name: '党的建设',
        component: () => import('@/front/party.vue'),
      },

      {
        path: '/aboutus',
        name: '关于我们',
        component: () => import('@/front/aboutus.vue'),
      },

      {
        path: '/search/:keyword',
        name: '搜索文章',
        component: () => import('@/front/search.vue'),
      },

    ]
  },

  //#################### 后台 ####################
  {
    path: '/login',
    name: '登录',
    component: () => import('@/back/login.vue'),
  },

  {
    path: '/admin',
    name: '',
    component: backLayout,
    children: [
      // {
      //   path: '',
      //   name: '后台首页',
      //   component: () => import('@/back/index.vue'),
      //   meta: {
      //     title: '后台首页',
      //     requireAuth: true,
      //   }
      // },

      
      {
        path: '/',
        name: 'list',
        component: () => import('@/back/list.vue'),
        meta: {
          title: '新闻列表',
          requireAuth: true,
        }
      },

      {
        path: '/issue',
        name: 'issue',
        component: () => import('@/back/issue.vue'),
        meta: {
          title: '新闻发布',
          requireAuth: true,
        }
      },

      {
        path: '/user',
        name: 'user',
        component: () => import('@/back/user.vue'),
        meta: {
          title: '用户管理',
          requireAuth: true,
        }
      },

      {
        path: '/category',
        name: 'category',
        component: () => import('@/back/category.vue'),
        meta: {
          title: '分类管理',
          requireAuth: true,
        }
      },

      {
        path: '/slide',
        name: 'slide',
        component: () => import('@/back/slide.vue'),
        meta: {
          title: '轮播图管理',
          requireAuth: true,
        }
      },

      {
        path: '/links',
        name: 'links',
        component: () => import('@/back/links.vue'),
        meta: {
          title: '友链管理',
          requireAuth: true,
        }
      },

      {
        path: '/system',
        name: 'system',
        component: () => import('@/back/system.vue'),
        meta: {
          title: '系统设置',
          requireAuth: true,
        }
      },

    ]
  },


  

]

Vue.use(Router)

export default new Router({
  mode: 'history',//后端支持可开
  //mode: 'hash',
  scrollBehavior:  () => ({y: 0}), //恢复到顶部
  routes: constantRouterMap,
})





// WEBPACK FOOTER //
// ./src/router/index.js